import { useState, createContext, useContext } from 'react';
import { PreferenceService, type PrefernceType } from '../core';
import { type PreferenceProviderProps, type PreferencesContextValue } from './types/propTypes';

const PreferenceServiceContext = createContext<PreferencesContextValue>({} as PreferencesContextValue);

const PreferenceProvider = (props: PreferenceProviderProps) => {
  PreferenceService.setPreferences(props.preferences);
  const [preferences, setPreferences] = useState(props.preferences);
  const updatePreferences = (preferences: PrefernceType) => {
    setPreferences(preferences);
    PreferenceService.setPreferences(preferences);
  };
  const value: PreferencesContextValue = {
    preferences: preferences as PrefernceType,
    updatePreferences: updatePreferences,
  };
  return <PreferenceServiceContext.Provider value={value}>{props.children}</PreferenceServiceContext.Provider>;
};

const usePreference = () => {
  const { preferences } = useContext(PreferenceServiceContext);
  return preferences;
};

const useSetPreference = (preferences: PrefernceType) => {
  const { updatePreferences } = useContext(PreferenceServiceContext);
  updatePreferences(preferences);
};

export default PreferenceProvider;
export { usePreference, useSetPreference };
export type { PreferenceProviderProps };
